document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('ProductRecommendations');
  if (!container) return;

  const url = container.dataset.url;
  if (!url) return;

  fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('#ProductRecommendations');
      if (recommendations && recommendations.innerHTML.trim().length > 0) {
        container.innerHTML = recommendations.innerHTML;
      }
    })
    .catch(e => console.error('Error loading recommendations:', e));
});